var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"speechToText"},[(!_vm.listening)?_c('div',{staticClass:"start",class:{'disable': _vm.disableSpeech},on:{"click":function($event){return _vm.start()}}}):_vm._e(),(_vm.listening)?_c('div',{staticClass:"stop",class:{'disable': _vm.disableSpeech},on:{"click":function($event){return _vm.stop()}}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }